<template><div><h1 id="zusagenfakturierung" tabindex="-1"><a class="header-anchor" href="#zusagenfakturierung"><span>Zusagenfakturierung</span></a></h1>
<p>Zusagenfakturierung — Inkasso versprochener Beiträge</p>
<h2 id="beschreibung" tabindex="-1"><a class="header-anchor" href="#beschreibung"><span>Beschreibung</span></a></h2>
<p>Die Zusagenfakturierung dient dem Inkasso versprochener Beiträge. Weitere Informationen sind im Kapitel <RouteLink to="/manual/customer/zusagen.html" title="11. Zusagenbearbeitung">Zusagenbearbeitung</RouteLink> beschrieben.</p>
<p>Pfad: <code v-pre>Personen → Verarbeitungsläufe → Zusagen → Zusagenfakturierung</code></p>
<h2 id="datenfelder" tabindex="-1"><a class="header-anchor" href="#datenfelder"><span>Datenfelder</span></a></h2>
<dl>
<dt>Job-ID</dt>
<dd>Vom System vergebene Nummer, die den Fakturierungslauf eindeutig identifiziert.</dd>
<dt>Job-Beschreibung (ohne Label)</dt>
<dd>Freier Text für die Beschreibung des Jobs.</dd>
<dt>Status</dt>
<dd>Systemfeld, welches den Status des Jobs anzeigt:
<table>
<thead>
<tr>
<th>Status</th>
</tr>
</thead>
<tbody>
<tr>
<td>erfasst, noch nicht aufbereitet</td>
</tr>
<tr>
<td>Zählung gestartet</td>
</tr>
<tr>
<td>Zählung abgebrochen</td>
</tr>
<tr>
<td>Aufbereitung läuft</td>
</tr>
<tr>
<td>aufbereitet</td>
</tr>
<tr>
<td>aufbereitet, mit fehlerhaften Belastungen</td>
</tr>
<tr>
<td>Aufbereitung abgebrochen</td>
</tr>
</tbody>
</table>
</dd>
<dt>Fakturierungstyp</dt>
<dd>Folgende Fakturierungstypen stehen zur Auswahl:| Typ | Beschreibung |
| --- | --- |
| neue Zusagen | Begrüssungsschreiben an die Neuzusager, mit/ohne ESR. |
| neue Zusagen (Sofortversand) | Für die automatische Fakturierung von Zusagen, die über eine Schnittstelle erfasst und verarbeitet werden. Z.B. jemand meldet sich über die Webseite für eine Mitgliedschaft an und wird sofort per E-Mail begrüsst. |
| alle Zusagen (ohne rollende) | Meist jährliche Fakturierung aller Zusagen zu einem bestimmten Datum. In der Regel wird ein Brief gedruckt und die Zusager mit Zahlungsart &quot;ESR&quot; erhalten 1 oder mehrere Einzahlungsscheine (je nach Anzahl Monatsraten) |
| Erneuerung (nur rollende) | Rollende jährliche Fakturierung, ausgehend vom Erfassungsdatum der Zusage. |
| Belastung LSV/DD | Fakturierung nach dem Lastschriftverfahren der Banken (LSV+) oder der Post (Debit Direct). Hierbei werden monatlich die Belastungsaufträge für die Bank/Post erstellt. |
| Belastung Kreditkarten | Fakturierung über die Kreditkarte. |
| Belastung E-Rechnungen | Mit dieser Fakturierung wird eine Rechnung für Paynet erstellt. |
| Mahnungen (ohne rollende) | Mahnung von nicht bezahlten Zusagenbeträgen aus nicht rollender Fakturierung. |
| Mahnungen (nur rollende) | Rollende Mahnung über das ganze Jahr, abgestimmt auf die rollende Fakturierung. |
| Austritte | Mit diesem Typ werden die Austritte der Zusagen durchgeführt. |</dd>
<dt>Fakturadatum</dt>
<dd>Datum der Fakturierung.</dd>
<dt>Zusagearten</dt>
<dd>Auswahl aus der Tabelle <a class="link" href="ft.refdata.tblzusart.html" title="Zusagen">Zusagen</a>.</dd>
<dt>LSV/DD/Kreditkarte: belasten am</dt>
<dd>Belastungsdatum für LSV, DD, Kreditkarte</dd>
<dt>Mahnungen: mahnen bis Fakturadatum</dt>
<dd>Fakturadatum der Zusagen, die berücksichtigt werden sollen.</dd>
<dt>Mahnungen: Mahnstufe</dt>
<dd>Zu mahnende Mahnstufe.</dd>
<dt>Parametrisierung Austritte: Austrittsdatum</dt>
<dd>Austrittsdatum der Zusage.</dd>
<dt>Parametrisierung Austritte: Grenzdatum</dt>
<dd>Grenzdatum für die Austritte.</dd>
<dt>Parametrisierung Austritte: Grenzjahr</dt>
<dd>Grenzjahr für die Austritte.</dd>
</dl>
<h2 id="funktionen" tabindex="-1"><a class="header-anchor" href="#funktionen"><span>Funktionen</span></a></h2>
<dl>
<dt>Filter...</dt>
<dd>Schränkt die angezeigten Zusagenfakturierungsjobs gemäss Filterkriterien ein.</dd>
<dt>Zählen...</dt>
<dd>Führt einen Zähllauf durch, der pro Position die Anzahl Fakturen anzeigt.</dd>
<dt>Aufbereiten, exportieren...</dt>
<dd>Erstellt und druckt die Fakturen. Folgende Optionen stehen zur Verfügung:<div class="itemizedlist"><ul class="itemizedlist" style="list-style-type: disc; "><li class="listitem">aufbereiten und Daten exportiren (alles):<br>Markiert die Adressen als fakturiert, erstellt PDF's resp. Textfiles und gibt diese, je nach Parametrisierung, auf den Drucker aus.</li><li class="listitem">aufbereiten:<br>Markiert die Adressen als fakturiert, erstellt PDF's resp. Textfiles.</li><li class="listitem">Daten exportieren (alles):<br>Druckt, bzw. exportiert die Daten inkl. Versand von E-Mails.</li><li class="listitem">Daten exportieren (ohne Sofortversand):<br>Druckt, bzw. exportiert die Daten ohne den Versand von E-Mails.</li><li class="listitem">Daten exportieren (Sofortversand):<br>Nur Versand von E-Mails.</li></ul></div></dd>
<dt>Transaktionen abschliessen...</dt>
<dd>Mit diesem Job werden LSV-Belastungen, die nicht bezahlt worden sind, zurückgesetzt. Weitere Informationen unter <a class="link" href="ft.refproc.zahlstlsvdd.html" title="Transaktionen abschliessen">Transaktionen abschliessen</a></dd>
<dt>Drucken...</dt>
<dd>Druckt den entsprechenden Zusagenfakturierungsjob aus.</dd>
</dl>
<h2 id="siehe-auch" tabindex="-1"><a class="header-anchor" href="#siehe-auch"><span>Siehe auch</span></a></h2>
<p><RouteLink to="/referenz/refs/ft.refproc.zahlstlsvdd.html" title="Transaktionen abschliessen">Transaktionen abschliessen</RouteLink> , <RouteLink to="/referenz/refs/ft.refdata.tblzusart.html" title="Zusagen">Zusagen</RouteLink> , <RouteLink to="/manual/customer/zusagen.html" title="11. Zusagenbearbeitung">Zusagenbearbeitung</RouteLink> , <RouteLink to="/referenz/refs/ft.refdata.zusfakpos.html" title="Zusagenfakturierung (Position)">Zusagenfakturierung (Positionen)</RouteLink></p>
</div></template>


